const countryList = [
  {
    id: 10,
    key: 10,
    name: 'Canada',
    latitude: null,
    longitude: null,
  },
  {
    id: 20,
    key: 20,
    name: 'United States',
    latitude: null,
    longitude: null,
  },
  {
    id: 30,
    key: 30,
    name: 'Mexico',
    latitude: null,
    longitude: null,
  },
]
const stateList = {
  10: [
    {
      key: 1,
      id: 1,
      name: 'Alberta',
      latitude: 35.491352,
      longitude: 139.28415,
    },
    {
      key: 3,
      id: 3,
      name: 'British Columbia',
      latitude: 35.676193,
      longitude: 139.65031,
    },
    {
      key: 84,
      id: 84,
      name: 'Manitoba',
      latitude: 35.01825,
      longitude: 137.29239,
    },
    {
      key: 110,
      id: 110,
      name: 'New Brunswick',
      latitude: 35.3292,
      longitude: 136.05632,
    },
  ],
}

const cityList = {
  1: [
    {
      key: 4,
      id: 4,
      name: 'Edmonton',
      latitude: 35.775017,
      longitude: 139.80441,
    },
    {
      key: 44,
      id: 44,
      name: 'Calgary',
      latitude: 35.775017,
      longitude: 139.80441,
    },
    {
      key: 444,
      id: 444,
      name: 'Red Deer',
      latitude: 35.775017,
      longitude: 139.80441,
    },
    {
      id: 4444,
      key: 4444,
      name: 'Lethbridge',
      latitude: 35.775017,
      longitude: 139.80441,
    },
    {
      id: 44444,
      key: 44444,
      name: 'St. Albert',
      latitude: 35.775017,
      longitude: 139.80441,
    },
  ],
}

const pincodeList = {
  44444: [
    {
      id: 8881,
      key: 8881,
      name: 'T8N 1A1',
      latitude: null,
      longitude: null,
    },
    {
      id: 8959,
      key: 8959,
      name: 'T8N 1B2',
      latitude: null,
      longitude: null,
    },
    {
      id: 8960,
      key: 8960,
      name: 'T8N 6C4',
      latitude: null,
      longitude: null,
    },
  ],
}

const buildingList = {
  8960: [
    {
      id: 378416,
      key: 378416,
      name: 'Sturgeon Community Hospital',
      latitude: null,
      longitude: null,
    },
  ],
}
const equipmentList = {
  378416: [
    {
      id: 378417,
      key: 378417,
      name: 'Eq 1',
      latitude: null,
      longitude: null,
    },
  ],
}
const distributorList = [
  {
    id: 10,
    key: 10,
    name: 'Daikin Comfort Technologies North America,Inc.',
    latitude: null,
    longitude: null,
  },
  {
    id: 20,
    key: 20,
    name: 'Distributor 1',
    latitude: null,
    longitude: null,
  },
  {
    id: 30,
    key: 30,
    name: 'Distributor 2',
    latitude: null,
    longitude: null,
  },
]
const contractorList = {
  10: [
    {
      id: 1,
      key: 1,
      name: 'Daikin Houston',
      latitude: 35.491352,
      longitude: 139.28415,
    },
    {
      id: 3,
      key: 3,
      name: 'Contractor 2',
      latitude: 35.676193,
      longitude: 139.65031,
    },
    {
      id: 84,
      key: 84,
      name: 'Contractor 3',
      latitude: 35.01825,
      longitude: 137.29239,
    },
    {
      id: 110,
      key: 110,
      name: ' Contractor 4',
      latitude: 35.3292,
      longitude: 136.05632,
    },
  ],
}
const feList = {
  1: [
    {
      id: 4,
      key: 4,
      name: 'EMP334',
      latitude: 35.775017,
      longitude: 139.80441,
    },
    {
      id: 44,
      key: 44,
      name: 'EMP123',
      latitude: 35.775017,
      longitude: 139.80441,
    },
    {
      id: 444,
      key: 444,
      name: 'EMP445',
      latitude: 35.775017,
      longitude: 139.80441,
    },
  ],
}

const forestList = {
  8959: [
    {
      id: 378416,
      key: 378416,
      name: 'Koajiro',
      latitude: 35.673695,
      longitude: 139.756058,
    },
  ],
}

const forestBackView = {
  378416: [
    {
      jobDetails: {
        id: 580650,
        jobId: 'f92691ad-7a63-437a-8680-75466449907a',
        jobTitle: null,
        customerBusinessNameTitle: null,
        buildingNameTitle: null,
        buildingAddressTitle: null,
        category: 1,
        subcategory: 2,
        jobType: 'RECOVERY',
        jobSubType: null,
        cylinderCount: 1,
        arrivalDate: null,
        arrivalDateTimeInMillis: null,
        lenderId: null,
        borrowerId: null,
        transporterId: null,
        dealerId: null,
        dealerTwoId: null,
        dealerThreeId: null,
        registrantId: 1158,
        jobControllerId: null,
        status: 'RECOVERY COMPLETED',
        creationDate: 'Oct/2025',
        modificationDate: 1693928404937,
        fullCount: null,
        lenderInfo: null,
        borrowerInfo: null,
        transporterInfo: null,
        jobControl: false,
        buildingId: 378338,
        contractorId: 1158,
        recycleFactoryId: null,
        customerId: 599107,
        disposalContractorId: null,
        transporterSendId: null,
        transporterReturnId: null,
        timeZone: 'Japan',
        active: false,
        contractorInfo: null,
        recycleFactoryInfo: null,
        requesterInfo: null,
        customerInfo: null,
        dealerInfo: null,
        dealerTwoInfo: null,
        dealerThreeInfo: null,
        equipmentInfo: null,
        buildingInfo: null,
        disposalContractorInfo: null,
        transporterSendInfo: null,
        transporterReturnInfo: null,
        processManagementReport:
          'https://dnum2o6eykwnz.cloudfront.net/job-reports/jpreProcessManagement_f92691ad-7a63-437a-8680-75466449907a.pdf',
        processManagementCustomerReport:
          'https://dnum2o6eykwnz.cloudfront.net/job-reports/jpreProcessManagementCustomer_f92691ad-7a63-437a-8680-75466449907a.pdf',
        processReceiptReport: null,
        recycleReport: null,
        recycleCertificate: null,
        disposalReport: null,
        fillCertificateReport: null,
        fillEquipmentTitle: '設置0台、設置外0台',
        recoveryEquipmentTitle: '整備1台、 廃棄0台',
        transportReceipt: null,
        cleanCylinder: false,
        transportRequired: false,
        ownedCylinderTransportRequired: false,
        processJobId: null,
        process: false,
        processType: 'ANY',
        ownedCylinderRentJob: null,
        connectedJob: null,
        jobCompletionDate: '19/07/2023',
        receptionCompletionDate: null,
        jobCompletionDateMillis: 1689724800000,
        receptionCompletionDateMillis: 0,
        managementNumber: '',
        appName: 'refnext',
        reportCount: 2782,
        processReceiptId: null,
        allProcessReceiptId: null,
        remark: '',
        recoveryMaintenanceReport:
          'https://dnum2o6eykwnz.cloudfront.net/job-reports/jpreRecoveryMaintenance_f92691ad-7a63-437a-8680-75466449907a.pdf',
        processManagementQr:
          'https://dnum2o6eykwnz.cloudfront.net/qr-codes/jpProcessManagement_f92691ad-7a63-437a-8680-75466449907a.png',
        processManagementCustomerQr:
          'https://dnum2o6eykwnz.cloudfront.net/qr-codes/jpProcessManagementCustomer_f92691ad-7a63-437a-8680-75466449907a.png',
        processReceiptQr:
          'https://dnum2o6eykwnz.cloudfront.net/qr-codes/jpProcessCertificate_f92691ad-7a63-437a-8680-75466449907a.png',
        fillCertificateQr: null,
        recycleReportQr: null,
        disposeReportQr: null,
        recycleCertificateQr: null,
        transportReceiptQr: null,
        ownedCylinderTransportReceiptQr: null,
        recoveryMaintenanceReportQr:
          'https://dnum2o6eykwnz.cloudfront.net/qr-codes/jpRecoveryMaintenance_f92691ad-7a63-437a-8680-75466449907a.png',
        stepNumber: 4,
        cylinderName: null,
        userJobId: null,
        read: null,
        action: 'CREATE',
        contractDealer: '[]',
        externalId: null,
        country: 'jp',
        installationCount: 0,
        otherCount: 0,
        maintenanceCount: 1,
        disposeCount: 0,
        canDelete: false,
        canRevert: false,
        retryButton: false,
        rentCylinderCapacity: '[]',
        rentCylinderQuantity: null,
        cylinderType: null,
      },
      refTypeRefrigerantAmount: {
        'R-134a': 4,
      },
      cfpCo2Amount: 400,
      mitigateCo2Amount: 400,
    },
    {
      jobDetails: {
        id: 580606,
        jobId: '9bcf15a4-89c5-4818-a3c7-2f0ed16e9ed3',
        jobTitle: null,
        customerBusinessNameTitle: null,
        buildingNameTitle: null,
        buildingAddressTitle: null,
        category: 1,
        subcategory: 2,
        jobType: 'RECOVERY',
        jobSubType: null,
        cylinderCount: 1,
        arrivalDate: null,
        arrivalDateTimeInMillis: null,
        lenderId: null,
        borrowerId: null,
        transporterId: null,
        dealerId: null,
        dealerTwoId: null,
        dealerThreeId: null,
        registrantId: 1158,
        jobControllerId: 1158,
        status: 'RECOVERY COMPLETED',
        creationDate: 'Nov/2024',
        modificationDate: 1696092182203,
        fullCount: null,
        lenderInfo: null,
        borrowerInfo: null,
        transporterInfo: null,
        jobControl: false,
        buildingId: 378338,
        contractorId: 1158,
        recycleFactoryId: null,
        customerId: 599107,
        disposalContractorId: null,
        transporterSendId: null,
        transporterReturnId: null,
        timeZone: 'Japan',
        active: false,
        contractorInfo: null,
        recycleFactoryInfo: null,
        requesterInfo: null,
        customerInfo: null,
        dealerInfo: null,
        dealerTwoInfo: null,
        dealerThreeInfo: null,
        equipmentInfo: null,
        buildingInfo: null,
        disposalContractorInfo: null,
        transporterSendInfo: null,
        transporterReturnInfo: null,
        processManagementReport:
          'https://dnum2o6eykwnz.cloudfront.net/job-reports/jpreProcessManagement_9bcf15a4-89c5-4818-a3c7-2f0ed16e9ed3.pdf',
        processManagementCustomerReport:
          'https://dnum2o6eykwnz.cloudfront.net/job-reports/jpreProcessManagementCustomer_9bcf15a4-89c5-4818-a3c7-2f0ed16e9ed3.pdf',
        processReceiptReport: null,
        recycleReport: null,
        recycleCertificate: null,
        disposalReport: null,
        fillCertificateReport: null,
        fillEquipmentTitle: '設置0台、設置外0台',
        recoveryEquipmentTitle: '整備1台、 廃棄0台',
        transportReceipt: null,
        cleanCylinder: false,
        transportRequired: false,
        ownedCylinderTransportRequired: false,
        processJobId: null,
        process: false,
        processType: 'RECYCLE',
        ownedCylinderRentJob: null,
        connectedJob: null,
        jobCompletionDate: '18/07/2023',
        receptionCompletionDate: null,
        jobCompletionDateMillis: 1689638400000,
        receptionCompletionDateMillis: 0,
        managementNumber: '',
        appName: 'refnext',
        reportCount: 2773,
        processReceiptId: null,
        allProcessReceiptId: null,
        remark: '',
        recoveryMaintenanceReport:
          'https://dnum2o6eykwnz.cloudfront.net/job-reports/jpreRecoveryMaintenance_9bcf15a4-89c5-4818-a3c7-2f0ed16e9ed3.pdf',
        processManagementQr:
          'https://dnum2o6eykwnz.cloudfront.net/qr-codes/jpProcessManagement_9bcf15a4-89c5-4818-a3c7-2f0ed16e9ed3.png',
        processManagementCustomerQr:
          'https://dnum2o6eykwnz.cloudfront.net/qr-codes/jpProcessManagementCustomer_9bcf15a4-89c5-4818-a3c7-2f0ed16e9ed3.png',
        processReceiptQr:
          'https://dnum2o6eykwnz.cloudfront.net/qr-codes/jpProcessCertificate_9bcf15a4-89c5-4818-a3c7-2f0ed16e9ed3.png',
        fillCertificateQr: null,
        recycleReportQr: null,
        disposeReportQr: null,
        recycleCertificateQr: null,
        transportReceiptQr: null,
        ownedCylinderTransportReceiptQr: null,
        recoveryMaintenanceReportQr:
          'https://dnum2o6eykwnz.cloudfront.net/qr-codes/jpRecoveryMaintenance_9bcf15a4-89c5-4818-a3c7-2f0ed16e9ed3.png',
        stepNumber: 4,
        cylinderName: null,
        userJobId: null,
        read: null,
        action: 'CREATE',
        contractDealer: '[]',
        externalId: null,
        country: 'jp',
        installationCount: 0,
        otherCount: 0,
        maintenanceCount: 1,
        disposeCount: 0,
        canDelete: false,
        canRevert: false,
        retryButton: false,
        rentCylinderCapacity: '[]',
        rentCylinderQuantity: null,
        cylinderType: null,
      },
      refTypeRefrigerantAmount: {
        'R-134a': 1,
      },
      cfpCo2Amount: 125,
      mitigateCo2Amount: 125,
    },
    {
      jobDetails: {
        id: 580596,
        jobId: '6ef48576-b481-44e9-961a-faf77ef27b85',
        jobTitle: null,
        customerBusinessNameTitle: null,
        buildingNameTitle: null,
        buildingAddressTitle: null,
        category: 1,
        subcategory: 2,
        jobType: 'RECOVERY',
        jobSubType: null,
        cylinderCount: 2,
        arrivalDate: null,
        arrivalDateTimeInMillis: null,
        lenderId: null,
        borrowerId: null,
        transporterId: null,
        dealerId: null,
        dealerTwoId: null,
        dealerThreeId: null,
        registrantId: 1158,
        jobControllerId: null,
        status: 'RECOVERY_AWAITING TRANSPORT',
        creationDate: 'Dec/2023',
        modificationDate: 1689653985861,
        fullCount: null,
        lenderInfo: null,
        borrowerInfo: null,
        transporterInfo: null,
        jobControl: false,
        buildingId: 378338,
        contractorId: 1158,
        recycleFactoryId: null,
        customerId: 599107,
        disposalContractorId: null,
        transporterSendId: null,
        transporterReturnId: null,
        timeZone: 'Japan',
        active: true,
        contractorInfo: null,
        recycleFactoryInfo: null,
        requesterInfo: null,
        customerInfo: null,
        dealerInfo: null,
        dealerTwoInfo: null,
        dealerThreeInfo: null,
        equipmentInfo: null,
        buildingInfo: null,
        disposalContractorInfo: null,
        transporterSendInfo: null,
        transporterReturnInfo: null,
        processManagementReport:
          'https://dnum2o6eykwnz.cloudfront.net/job-reports/jpreProcessManagement_6ef48576-b481-44e9-961a-faf77ef27b85.pdf',
        processManagementCustomerReport:
          'https://dnum2o6eykwnz.cloudfront.net/job-reports/jpreProcessManagementCustomer_6ef48576-b481-44e9-961a-faf77ef27b85.pdf',
        processReceiptReport: null,
        recycleReport: null,
        recycleCertificate: null,
        disposalReport: null,
        fillCertificateReport: null,
        fillEquipmentTitle: '設置0台、設置外0台',
        recoveryEquipmentTitle: '整備1台、 廃棄0台',
        transportReceipt: null,
        cleanCylinder: false,
        transportRequired: false,
        ownedCylinderTransportRequired: false,
        processJobId: null,
        process: false,
        processType: 'RECYCLE',
        ownedCylinderRentJob: null,
        connectedJob: null,
        jobCompletionDate: '18/07/2023',
        receptionCompletionDate: null,
        jobCompletionDateMillis: 1689638400000,
        receptionCompletionDateMillis: 0,
        managementNumber: '',
        appName: 'refnext',
        reportCount: 2771,
        processReceiptId: null,
        allProcessReceiptId: null,
        remark: '',
        recoveryMaintenanceReport:
          'https://dnum2o6eykwnz.cloudfront.net/job-reports/jpreRecoveryMaintenance_6ef48576-b481-44e9-961a-faf77ef27b85.pdf',
        processManagementQr:
          'https://dnum2o6eykwnz.cloudfront.net/qr-codes/jpProcessManagement_6ef48576-b481-44e9-961a-faf77ef27b85.png',
        processManagementCustomerQr:
          'https://dnum2o6eykwnz.cloudfront.net/qr-codes/jpProcessManagementCustomer_6ef48576-b481-44e9-961a-faf77ef27b85.png',
        processReceiptQr: null,
        fillCertificateQr: null,
        recycleReportQr: null,
        disposeReportQr: null,
        recycleCertificateQr: null,
        transportReceiptQr: null,
        ownedCylinderTransportReceiptQr: null,
        recoveryMaintenanceReportQr:
          'https://dnum2o6eykwnz.cloudfront.net/qr-codes/jpRecoveryMaintenance_6ef48576-b481-44e9-961a-faf77ef27b85.png',
        stepNumber: 4,
        cylinderName: null,
        userJobId: null,
        read: null,
        action: 'CREATE',
        contractDealer: '[]',
        externalId: null,
        country: 'jp',
        installationCount: 0,
        otherCount: 0,
        maintenanceCount: 1,
        disposeCount: 0,
        canDelete: false,
        canRevert: false,
        retryButton: false,
        rentCylinderCapacity: '[]',
        rentCylinderQuantity: null,
        cylinderType: null,
      },
      refTypeRefrigerantAmount: {
        'R-22': 3.8999999,
      },
      cfpCo2Amount: 300,
      mitigateCo2Amount: 300,
    },
  ],
}
const filterByList = [
  { label: 'User 1', value: 1 },
  { label: 'User 2', value: 2 },
  { label: 'User 3', value: 3 },
  { label: 'User 4', value: 4 },
  { label: 'User 5', value: 5 },
  { label: 'User 6', value: 6 },
  { label: 'User 7', value: 7 },
  { label: 'User 8', value: 8 },
]
const equipmentTableData = [
  {
    key: 1,
    productSeriesInfo: 'Intelligent VAV Systems',
    modelInfo: 'JSH34',
    maintenance: { created: 26, closed: 20 },
    repair: { created: 16, closed: 4 },
  },
]
const feTableData = [
  { brandInfo: 'Daikin', repairCount: 77, maintenanceCount: 100, key: 1 },
  { brandInfo: 'Goodman', repairCount: 25, maintenanceCount: 65, key: 2 },
  { brandInfo: 'Amana', repairCount: 78, maintenanceCount: 98, key: 3 },
  { brandInfo: 'Carrier', repairCount: 56, maintenanceCount: 76, key: 4 },
  { brandInfo: 'Trane', repairCount: 44, maintenanceCount: 55, key: 5 },
  { brandInfo: 'York', repairCount: 51, maintenanceCount: 50, key: 6 },
  {
    brandInfo: 'Johnson Control',
    repairCount: 76,
    maintenanceCount: 84,
    key: 7,
  },
]
const equipmentChartData = [
  { name: 'A3', value: 4 || null, color: '#4672bd' },
  { name: 'A9', value: 14 || null, color: '#d7e3ef' },
  { name: 'C1', value: 15 || null, color: '#2f71ac' },
  { name: 'A6', value: 29 || null, color: '#d3dfeb' },
  { name: 'A8', value: 24 || null, color: '#5e9ad0' },
  { name: 'C3', value: 14 || null, color: '#89a3d0' },
]

const colorCodes = [
  '#4672bd',
  '#d7e3ef',
  '#2f71ac',
  '#d3dfeb',
  '#5e9ad0',
  '#89a3d0',
  '#6495ED',
  '#FFD700',
  '#B8860B',
  '#DAA520',
  '#EEE8AA',
  '#BDB76B',
  '#F0E68C',
  '#808000',
  '#FFFF00',
  '#9ACD32',
  '#556B2F',
  '#6B8E23',
  '#7CFC00',
  '#7FFF00',
  '#ADFF2F',
  '#006400',
  '#008000',
  '#228B22',
  '#00FF00',
  '#32CD32',
  '#90EE90',
  '#98FB98',
  '#8FBC8F',
  '#00FA9A',
  '#00FF7F',
  '#2E8B57',
  '#66CDAA',
  '#3CB371',
  '#20B2AA',
  '#2F4F4F',
  '#008080',
  '#008B8',
  '#6A5ACD',
  '#7B68EE',
  '#9370DB',
  '#8B008B',
  '#9400D3',
  '#9932CC',
  '#BA55D3',
  '#800080',
  '#D8BFD8',
  '#DDA0DD',
  '#EE82EE',
  '#FF00FF',
  '#DA70D6',
  '#C71585',
  '#DB7093',
  '#FF1493',
  '#FF69B4',
  '#FFB6C1',
  '#FFC0CB',
  '#FAEBD7',
  '#F5F5DC',
  '#FFE4C4',
  '#FFEBCD',
  '#F5DEB3',
  '#FFF8DC',
  '#FFFACD',
  '#FAFAD2',
  '#FFFFE0',
  '#8B4513',
  '#A0522D',
  '#D2691E',
  '#CD853F',
  '#F4A460',
  '#DEB887',
  '#D2B48C',
  '#BC8F8F',
  '#FFE4B5',
  '#FFDEAD',
  '#FFDAB9',
  '#FFE4E1',
  '#FFF0F5',
  '#FAF0E6',
  '#FDF5E6',
  '#FFEFD5',
  '#FFF5EE',
  '#F5FFF',
]

export {
  colorCodes,
  countryList,
  stateList,
  cityList,
  pincodeList,
  buildingList,
  equipmentList,
  distributorList,
  contractorList,
  feList,
  forestList,
  forestBackView,
  filterByList,
  equipmentTableData,
  feTableData,
  equipmentChartData,
}
